import { useTheme } from '@material-ui/core'
import { OpenSolarThemeType } from 'Themes'

export function useOpenSolarTheme() {
  return useTheme<OpenSolarThemeType>()
}
